import { boolean, object, string, number } from "yup";
import User from "../../../interfaces/user.interface";
import Title from "antd/lib/typography/Title";

export const courseRegistrationScheme = object({
  id: number(),
  title: string().required(),
  email: string().email().required(),
  contactEmail: string().email().required(),
  phone: string().required(),
  designation: string().required(),
  lastName: string().required(),
  firstName: string().required(),
  member: string().required(),
  membership: string(),
  country: string().required(),
  province: string().required(),
  city: string().required(),
  address: string().required(),
  aptSuite: string(),
  zipCode: string().required(),
  waitList: boolean(),
  licensePurchase: boolean(),
  course: object(),
});

export const courseRegistrationValues = (user: User) => {
  return {
    id: user?.id || 0,
    title: user?.title || "mr",
    phone: user?.phone || "",
    email: user?.email || "",
    contactEmail: user?.contactEmail || "",
    designation: user?.designation || "",
    lastName: user?.lastName || "",
    firstName: user?.firstName || "",
    member: user?.member || "",
    membership: user?.membership || "",
    country: user?.country || "",
    province: user?.province || "",
    city: user?.city || "",
    address: user?.address || "",
    aptSuite: user?.aptSuite || "",
    zipCode: user?.zipCode || "",
    waitList: false,
    licensePurchase: false,
    course: {},
  };
};

export const generalInfoContent = (title: string, value: string) => {
  return (
    <div className="flex flex-col items-baseline px-4">
      <Title level={3} style={{ fontWeight: "400" }}>
        {title}:
      </Title>
      <div
        className="custom-format text-base"
        style={{ fontWeight: "300" }}
        dangerouslySetInnerHTML={{ __html: String(value) }}
      />
    </div>
  );
};
